function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("title", null, "Icon");

var _ref3 =
/*#__PURE__*/
React.createElement("desc", null, "Created with Sketch.");

var _ref4 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("linearGradient", {
  x1: "50%",
  y1: "0%",
  x2: "50%",
  y2: "100%",
  id: "linearGradient-1"
}, React.createElement("stop", {
  stopColor: "#FF69B4",
  offset: "0%"
}), React.createElement("stop", {
  stopColor: "#FF1493",
  offset: "100%"
})));

var _ref5 =
/*#__PURE__*/
React.createElement("g", {
  id: "Icon",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("circle", {
  id: "Oval",
  fill: "#000000",
  cx: 256,
  cy: 256,
  r: 256
}), React.createElement("path", {
  d: "M256,25 C128.391129,25 25,128.391129 25,256 C25,383.608871 128.391129,487 256,487 C383.608871,487 487,383.608871 487,256 C487,128.391129 383.608871,25 256,25 Z M256.5,443 C153.64525,443 70,359.35475 70,256.5 C70,153.64525 153.64525,70 256.5,70 C359.35475,70 443,153.64525 443,256.5 C443,359.35475 359.35475,443 256.5,443 Z M376.294745,158.869595 C372.750531,154.760921 366.68806,153.827132 362.02462,156.535122 L287.40959,201.35702 C284.051913,203.411357 282,207.053136 282,210.975052 C282,214.896968 284.051913,218.538747 287.40959,220.593084 L362.02462,265.414982 C367.061135,268.403109 373.030337,266.909046 376.294745,263.080509 C379.838959,258.878456 379.932228,252.808824 376.388014,248.606771 L345.049701,210.975052 L376.388014,173.343333 C379.932228,169.14128 379.838959,162.978269 376.294745,158.869595 Z M230,210.995507 C230,207.075023 227.948087,203.434574 224.59041,201.380987 L149.97538,156.575454 C145.31194,153.775108 139.249469,154.801901 135.705255,158.909075 C132.161041,163.109594 132.067772,169.17701 135.611986,173.377529 L166.950299,210.995507 L135.611986,248.613486 C132.067772,252.814005 132.161041,258.881421 135.705255,263.08194 C138.969663,266.909079 144.938865,268.402597 149.97538,265.415561 L224.59041,220.610028 C227.948087,218.556441 230,214.915992 230,210.995507 L230,210.995507 Z M255.500791,271 C213.243426,271 161.585192,306.564732 155.162817,357.636801 C153.766649,368.594081 161.585192,377.694195 169.589892,374.258438 C190.718574,365.251182 221.992748,360.143975 255.500791,360.143975 C289.008835,360.143975 320.283008,365.251182 341.411691,374.258438 C349.323312,377.694195 357.234934,368.686939 355.838765,357.636801 C349.41639,306.564732 297.758157,271 255.500791,271 Z",
  id: "Face",
  fill: "url(#linearGradient-1)",
  fillRule: "nonzero"
}));

var SvgFaceLogo = function SvgFaceLogo(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: "512px",
    height: "512px",
    viewBox: "0 0 512 512",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? React.createElement("title", null, title) : null, _ref3, _ref4, _ref5);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgFaceLogo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/FaceLogo.07e52b06.svg";
export { ForwardRef as ReactComponent };